import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-login-required-sheet',
  templateUrl: './login-required-sheet.component.html',
  styleUrls: ['./login-required-sheet.component.css'],
})
export class LoginRequiredSheetComponent {

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private nav: NavigationService
  ) { }

  close() {
    this.modalCtrl.dismiss();
  }

  goToLogin() {
    const currentUrl = this.router.url;
    localStorage.setItem('returnUrl', currentUrl);

    this.modalCtrl.dismiss();
    this.nav.login();
  }
}
